const translation = {
  // Параметры в таких скобках {{ }} являются изменяемыми. Для других языков
  // просто подставить эти скобки в другое место. Сбоку будет пример значения в скобках
  1001: 'Watch trailer',
  1002: 'Password',
  1003: 'E-mail',
  10031: 'Enter your e-mail',
  1004: 'Name',
  10041: 'Registration complete!',
  10042: 'You can now log in',
  1005: 'Log in',
  1006: 'Sign up',
  1007: 'Show map',
  1008: 'Wallet address',
  1009: 'Forgot password',
  1010: 'By sending this form I confirm that I have read',
  1011: 'Create new account',
  1012: 'Register',
  1013: 'Back to LOG IN',
  1014: 'Reset password',
  1015: 'We will send you a code to change your password',
  1016: 'Resend code',
  10171: 'New password',
  10172: 'Confirm new password',
  1017: 'Enter new password',
  1018: 'Confirm new password',
  1019: 'Send code',
  1020: 'Enter code from email',
  1021: 'Resend code in {{ param1 }}',
  1022: 'User not found',
  1023: 'Incorrect login/password pair',
  1024: 'This field is mandatory',
  1025: 'Minimum length {{ param1 }}',
  1026: 'Maximum length {{ param1 }}',
  1027: 'REGISTRATION COMPLETE',
  1028: 'Now you need to VERIFY YOUR ACCOUNT',
  1029: 'Link has been sent to e-mail<br /> {{ param1 }}',
  10291: 'Code has been sent to e-mail<br /> {{ param1 }}',
  1030: 'Main',
  1031: 'Analytics',
  1032: 'HexaTraiding',
  1033: 'Inventory',
  1034: 'Store',
  1035: 'This hex is not available for purchase',
  1036: 'My Location',
  1037: 'Grid',
  1038: 'Numbers',
  1039: 'On sale',
  1040: '{{ param1 }} hexatiles selected',
  1041: 'Clear selection',
  1042: 'Select mode',
  1043: "You don't have an Advisor for this hexatile",
  1044: '{{ param1 }} is your property now.',
  1045: 'Your purchase has not been completed',
  1046: 'To buy hexatiles, enter your personal code',
  1047: 'Code Error',
  1048: 'This code was entered incorrectly or has already been used before.',
  10481: 'Now you can  buy your first Hexatile!',
  1049: 'Your offer in Reex coins',
  1050: 'Start offer',
  1051: 'Details',
  1052: 'Your bid is waiting for an answer',
  1053: 'Bid will be canceled in {{ param1 }} days',
  1054: 'price to start bidding',
  1055: 'Bidding offers in',
  1056: 'Orbs',
  1057: 'Orb hacks',
  1058: 'Resource types',
  1059: 'Population activity',
  1060: 'Community activity',
  1061: 'Buy land',
  1062: 'Price owner',
  1063: 'Put up for sale',
  1064: 'Belongs to user {{ param1 }}',
  1065: 'Advisor is allowed to independently place standard orbs, shards, coins and other objects on controlled hexatiles.',
  1066: 'Controlled areas list',
  1067: 'Chief Advisor',
  1068: 'You can customize your Advisor by adding improvements.',
  1069: 'All upgrades can be purchased in the Store.',
  1070: 'Buy new land to activate this Advisor',
  1071: '(not activated)',
  1072: 'Buy in the Store',
  1073: 'Use',
  1074: 'Are you sure you want to use this object?',
  1075: 'Replacing the current upgrade will destroy the previous inserted object',
  1076: 'You have no filled orbs',
  1077: 'Error loading file!',
  1078: 'Please try again later...',
  1079: 'You are out of ORBs!',
  1080: 'Please use an internal address to retrieve them from your wallet. If you are out of context, please refer to the person who recommended you to join Legends of Interaction. ',
  1081: 'Upload your image',
  1082: 'Green standard orbs',
  1083: 'Blue standard orbs',
  1084: 'Red standard orbs',
  1085: 'Filled',
  1086: 'Fill',
  1087: 'Interactions',
  1088: 'Regeneration time',
  1089: 'Resources per interaction',
  1090: 'Per interaction',
  1091: 'Per interaction for Player',
  1092: 'Per interaction for Master',
  1093: 'New billboard',
  1094: 'Templates',
  1095: 'Enter text',
  1096: 'Fill advertising orbs',
  1097: 'Fill advertising orb map',
  1098: "Your template has been sent for moderation, it won't take long",
  1099: 'You will be able to use advertising orbs when you have at least 1 template that has passed moderation.',
  1100: 'Send to moderation',
  1101: 'You have no templates yet. Create a new billboard!',
  1102: 'Advertising orb «{{ param1 }}» is filled',
  1103: 'Now you can place it on the map',
  1104: 'Shards will be available for placement soon',
  1105: 'LOI activity',
  1106: 'Population density',
  1107: 'Investments and forecasts',
  1108: 'Cultural heritage sites',
  1109: 'Are you sure you want to cancel this purchase?',
  1110: 'This action will end bidding and the hexatile information will return to the "World" tab',
  1111: 'Yes, I want to cancel purchase',
  1112: 'No, return to bids',
  1113: 'Enter your bid',
  1114: 'Your bid has been sent.',
  1115: 'Information about this Hexatile is now in the "Buy" tab.',
  1116: 'View bids',
  1117: 'View on map',
  1118: 'Enter amount',
  1119: 'Enter haxatile ID',
  1120: 'Send to my wallet',
  1121: "Don't have a wallet address?",
  1122: 'You can get it here',
  1123: 'Please, enter your external wallet address',
  1124: 'Send to my external wallet',
  1125: 'Place on the map',
  1126: "You don't have enough money",
  1127: 'The Advisor analyzes the data and collects relevant information.',
  1128: 'You will receive the following recommendations in about 1 hour.',
  1129: 'Nothing has happened in this area for a long time!',
  1130: 'If this continues, in 30 days, this area will acquire the "UNOCCUPIED" status.',
  1131: 'Areas converted into NFTs may remain inactive indefinitely.',
  1132: 'Do you want to change wallet address?',
  1133: 'Transactions sent to the previous wallet will be lost.',
  1134: 'Purchase completed.',
  1135: '{{ param1 }} {{ param2 }} added to your inventory.',
  1136: 'Go to Store',
  1137: 'To buy this land, you need to purchase a new Advisor.',
  1138: 'Bid closed.',
  1139: 'Specify recipient',
  1140: 'User ID',
  1141: 'Are you sure you want to buy?',
  1142: 'You are not logged in.',
  1143: 'Stay in guest mode',
  1144: 'Some functions will be unavailable',
  1145: 'Are you sure you want to buy?',
  1146: 'Are you sure you want to put hexatile {{ param1 }} up for sale?',
  1147: '{{ param1 }} was sold to user [{{ param2 }}] for {{ param3 }}',
  1148: 'Are you sure you want to sell hexatile {{ param1 }}?',
  1149: 'We charge a commisiion fee of {{ param1 }}% (no more than 1 and no less than {{ param2 }} Reex Coin)',
  1150: 'Are you sure you want to put this object on the map??',
  1151: 'This action is irreversible.',
  1152: 'Are you sure you want to log out?',
  1153: 'Most functions will become unavailable',
  1154: 'The Orb placement limit on this Hexatile has been reached.',
  1155: "Select <span style='color: #FF9326'>another</span> purchased Hexatile.",
  1156: 'This hex does not belong to you',
  1157: 'Are you sure you want to put Hexatile up for sale?',
  1158: "You indicated the price <img src='/svgs/reex.svg' style='margin: 0 2px -10px 0'/> {{ param1 }}",
  1159: 'Are you sure you want to start bidding ?',
  1160: "<img src='/svgs/reex.svg' style='margin: 0 2px -10px 0'/> {{ param1 }} will be locked in your wallet.",
  1161: "Are you sure you want to buy <span style='color: #FF9326'>{{ param1 }}</span> Hexatiles?",
  1162: "Are you sure you want to buy {{ param2 }} ( <span style='color: #FF9326;'>{{ param1 }}</span> )",
  1163: 'It will cost for <customIcon/> {{ param3 }}',
  1164: 'My structures',
  1165: 'Referral',
  1166: 'Referral history',
  1167: 'Enter your Antallagí.io referral number',
  1168: 'By doing this, you will link your Antallagí.io profile to your Masters of Game back office.',
  1169: 'As a result, all users you have invited through the Masters of Game referral program will see your offers in priority order when they proceed from their personal back office to Antallagí.io.',
  1170: 'Please note that your balance may show a negative HEXA COIN amount. This is due to the fact that the Masters of the Game system is still in testing and active development. In some cases, HEXA COIN was deducted from your balance significantly later than the actual registration of the hexatile purchase.',
  1171: 'We kindly ask for your understanding and request you to check your balance in the "My Assets" section. If your HEXA COIN balance is negative, please replenish it as soon as possible.',
  1172: 'Please be aware that while your balance is negative, some features related to fund withdrawals may be temporarily unavailable.',
  1173: 'Bonus',
  1174: "Don't show again",
  1175: 'Dear Master of the Game!',
  1176: 'Thank you for your understanding and support!',
  1177: 'Slot',
  1178: 'Understood',
  1179: 'Modification',
  1180: 'Coming soon',
  1181: 'My assets',
  1182: 'Search',
  1183: 'Select',
  1184: 'Light',
  1185: 'Layers',
  1186: 'Dark',
  1187: 'Personal account',
  1188: 'Boosters',
  1189: 'Objects',
  1190: 'Cadastral value',
  1191: '{{ param1 }} Рrice',
  1192: 'Set new price',
  1193: 'Cancel purchase',
  1194: 'Estimated price',
  1195: 'Current price',
  1196: 'Your bid in Reex',
  1197: 'min',
  1198: 'max',
  1199: 'Cancel sale',
  1200: 'It will cost <customIcon/> {{ param1 }}.',
  1201: "User {{ param1 }}' price",
  1202: 'Send',
  1203: 'Cancel',
  1204: 'Buy',
  1205: 'Sell',
  1206: 'My',
  1207: 'World',
  1208: 'Empty',
  1209: 'Resources',
  1210: 'Confirm',
  1211: 'Cancel',
  1212: 'Border',
  1213: 'Text',
  1214: "User's",
  1215: 'My account',
  1216: 'Language',
  1217: 'Username',
  12171: 'Ranking',
  12172: 'Owned hexatiles',
  1218: 'Internal',
  1219: 'Transactions',
  1220: 'Change password',
  1221: 'Log out',
  1222: 'Personal data',
  1223: 'Advisors',
  1224: 'Others',
  1225: 'OK',
  1226: 'Nothing found',
  1227: 'coin',
  1228: 'Owned',
  1229: 'Unoccupied',
  1230: 'Congratulations',
  1231: 'Character limit',
  1232: 'Collection',
  1233: 'Locked',
  1234: 'Approve',
  1235: 'Save',
  1236: 'Events',
  1237: 'Trade',
  1238: 'My activity',
  1239: 'Layer',
  1240: 'iawallet.net',
  1241: 'I am not a US citizen and/or tax resident',
  1242: 'Citizens and tax residents of the United States of America are currently unable to register as Game Masters.',
  1243: 'Learn more',
  1244: 'You have selected to buy {{ param1 }} Hexatiles',
  1245: 'use non-activated',
  1246: 'use non-activated advisor',
  1247: 'Dashboard',
  1248: 'LEADERBOARD',
  12481: 'View leaderboard',
  1249: 'Referral system',
  1250: 'A special coin that allows a Master of Game to connect his/her Advisor to the TerritoryX program.',
  1251: 'The program gives the opportunity to collaborate with companies in the real world and involve them in the Game by selling access to your tterritories and player audience.',
  1252: 'Thanks to TerritoryX, your digital holdings turn into assets that can bring you real income.',
  1253: "Open the door to the future with the <span style='color: #FF9326;'>TerritoryX</span> program — digital territories that generate real income!",
  1254: "TerritoryX is a platform that provides businesses and entrepreneurs with gamification tools for attracting and retaining customers, integrated with the <span style='color: #FFF172'>LEGENDS OF INTERACTIONS</span>.",
  1255: 'You create a platform for interaction between real businesses and players, turning advertising into gamification. And you receive income from advertising placed on your venue.',
  1256: "<span color='#FFF172'>TerritoryX</span> erases all boundaries between the real and virtual worlds. Your digital lands can be as valuable as real estate in the city center. And what's more important — you control them.",
  1257: 'You connect TerritoryX — and open up the opportunity for businesses to place advertising assets directly on your territory. You manage your own media platform that attracts business and turns it into financial flows.',
  1258: 'We will inform you about the launch of TerritoryX in advance!',
  1259: "And now you can connect your Advisors to <span style='color: #FF9326'>TerritoryX</span> on particularly favorable terms!",
  1260: "In order to connect to TerritoryX, a special coin is required — <span style='color: #FF9326'>DOMINION Coin</span>.",
  1261: "The creation of DOMINION Coin is available to those community members who stand at the origins of <span style='color: #FF9326'> LEGENDS OF INTERACTIONS </span>.",
  1262: 'If you have this coin, send it to your back office and activate the Advisors already now.',
  1263: 'If you do not have a DOMINION Coin or do not know where to get one, contact the person who invited you to become the Master of Game.',
  1264: 'DOMINION Coin is the key to generating income from your digital tterritories.',
  1265: 'Upon immediate activation of TerritoryX for your Advisor, the start date of the program operation will be considered the launch date of the TerritoryX system.',
  1266: 'For every DOMINION Coin spent you will receive 1 OCTA Coin!',
  1267: "By activating <span style='color: #FF9326'>TerritoryX</span> for your Advisors right now:",
  1268: 'you get favorable conditions for the connection period;',
  1269: "you don't waste time, as the two-year period will only start counting down after the launch of TerritoryX;",
  1270: 'you receive OCTA Coin — a premium coin for players — right now;',
  1271: 'you bring the moment of launching TerritoryX closer. Each activated Advisor increases the impact of the offer on the advertising market.',
  1272: 'Turn your digital possessions into assets that can generate real income!',
  1273: "Connect your Advisor to TerritoryX right now and extend the program's validity period <span style='color: #FF9326'>BY TWO TIMES</span>!",
  1274: 'Give the business access to your territories and player audience on favorable terms.',
  1275: 'DOMINION Coin is the key to generating income from your digital territories.',
  1276: 'If you do not have DOMINION Coin or do not know where to get it, contact <br /> the person who invited you to become the Master of Game.',
  1277: 'Subscription paused.',
  1278: "Participation in TerritoryX has been suspended because a booster that increases the Advisor's geographic area of influence has been applied. <span style='color: #FF9326'>You need to update</span> your subscription plan in accordance with the changed Advisor parameters.",
  1279: 'Upon immediate activation of TerritoryX for your Advisor, the start date of the program operation will be considered the launch date of the TerritoryX system.',
  1280: 'Take advantage of the opportunity and extend the validity period of TerritoryX on especially favorable terms right now!',
  1281: 'Dear Master of Game!',
  1282: "<span style='color: #FF9326'>Please note</span>: you can get a root referral number* for purchasing 7,286 hexatiles only until 30.04.2025.",
  1283: 'In the future, you will need to purchase significantly more plots of virtual land in order to get a root number!',
  1284: '*The root number — the number of the owner of the referral structure. It allows creating and leading your own structure of the Masters of Game.',
  1285: 'Rented',
  1286: 'Top up your balance',
  1287: 'the choice is still available at the lower level of hexes',
  1288: 'Objects are <span style="font-weight: bold">NOT</span> visible at this zoom',
  1289: 'Objects are visible at this zoom',
  1290: 'Objects can only be placed at a zoom greater than 19',
  1291: 'Click on the map to set the object',
  1292: 'Click outside the map to exit installation mode',
  1293: 'Press ESC to exit installation mode',
  1294: 'Hold ctrl and select hexes',
  1295: 'Click and drag to extract the hexagons in a circle',
  1296: 'Click outside the map to exit selected mode',
  1297: 'Antallagί.io',
  1298: 'We have chosen a decentralized exchange system — all offers to buy and sell assets and game objects are posted by community members and enthusiasts of the Game’s economic development.',
  1299: 'Topical offers on reasonable exchange terms!',
  1300: 'On the Marketplace, you will find everything you need as a Master of Game at the fairest prices — after all, the offers are made by active community members who are deeply immersed in the topic.',
  1301: 'Do you want to buy land in the Game?',
  1302: 'You need HEXA Coins, here you can find them and get them in the required quantity!',
  1303: "<ul style={{paddingTop: '0'}}><li style={{color: colors.white, paddingBottom: '10px'}}><span style={{color: colors.orange}}>Orbs and game resources</span>: [HEXA Сoin] — buy land in the Game. [Orbs] — place objects for players on your land. [REEX Coin] — buy boosters for Advisors.</li><li style={{color: colors.white, paddingBottom: '10px'}}>Any <span style={{color: colors.orange}}>assets</span> required for actions within the Masters of Game back office.</li><li style={{color: colors.white, paddingBottom: '10px'}}>All game <span style={{color: colors.orange}}>resources</span> put up for sale by the Game participants can become your assets without wasting time and unnecessary risks, thanks to the exchange protocol!</li><li style={{color: colors.white, paddingBottom: '10px'}}>Whatever you are looking for, all available offers for the sale of the assets you need, compiled by participants in the Game economy, are here!</li></ul>",
  1304: 'Antallagί.io is a platform for fast, safe and convenient exchange of digital resources on the Netsbo.io blockchain.',
  1305: 'Antallagί.io is based on a decentralized protocol that guarantees maximum transparency and protection.',
  1306: 'The exchange is carried out by smart contracts automatically, subject to the set conditions and is possible only according to clear rules, with the consent of all participants — no risks, only fair deals!',
  1307: 'Make profitable exchanges today!',
  1308: 'Coming Soon...',
  1309: '<span style={{color: colors.orange}}>Intermediary </span> is a tool designed to significantly simplify the interaction of Masters of Game with the Antallagí.io Marketplace.',
  1310: 'This section will display all active applications from the Antallagí protocol related to Masters of Game.',
  1311: 'The main advantage of the intermediary is the ability to pay for the goods in any convenient way: Bitcoin (BTC), Ethereum (ETH), stablecoins, REEX Coin, QUARTER Coin, including payment in fiat currencies (traditional money).',
  1312: 'How does it work?',
  1313: "<ul style={{paddingTop: '0'}}><li style={{color: colors.white, paddingBottom: '10px'}}>You choose the desired product.</li><li style={{color: colors.white, paddingBottom: '10px'}}>Pay for it in any convenient way.</li><li style={{color: colors.white, paddingBottom: '10px'}}>After confirming the payment, the intermediary purchases the chosen items on Antallagí.io.</li><li style={{color: colors.white, paddingBottom: '10px'}}>The purchased items are sent to your internal address in the Masters of Game back office.</li></ul>",
  1314: 'When working with an intermediary, the Antallagí referral link is taken into account.',
  1315: 'Next payment',
  1316: 'Rented hexatiles cannot be sold',
  1317: 'Buy for Reex coins',
  1318: 'If the selected advisor does not fit all the selected hexatiles, then a free advisor from your inventory will be automatically used',
  1319: 'Advisor name',
  13191: 'Buy for <customIcon/> {{ price }}',
  1320: 'Free <span style={{color: colors.gray}}>(used)</span>',
  13201: 'Free (used)',
  1321: 'Count',
  1322: 'Your Advisors',
  1323: 'Selected:',
  1324: 'Non-activated Advisors',
  1325: "<span style={{color: colors.orange, marginRight: '8px'}}>{{param1}} </span>hexatiles will be included in the new advisor",
  1326: 'Or',
  1327: 'To activate a new advisor, you first need to purchase it.',
  1328: 'No advisors',
  1329: 'You have reached status <span style={{color: colors.orange}}>{{param1}}</span> !',
  1330: 'You already own <span style={{color: colors.orange}}>{{param1}}</span> Hexatiles!',
  1331: 'Continue to expand your holdings, there are even more <span style={{color: colors.orange}}> opportunities</span> and <span style={{color: colors.orange}}>unique privileges</span> ahead!',
  1332: 'Change location from Google Maps',
  1333: 'Your link must contain location coordinates.',
  1334: 'Enter Receiver',
  1335: 'Purchased hexatiles',
  1336: 'Hexatiles ON SALE',
  1337: 'Purchase offers',
  1338: 'Back to controlled areas list',
  1339: 'Parameters',
  1340: 'Messages',
  1341: 'Locked Hexatiles: {{param1}}',
  1342: 'This parameter determines the radius of the territory that the adviser can explore.',
  1343: 'This improvement expands the coverage area by 100 square meters.',
  1344: "You don't have boosters for this slots. <br /> You can buy them at the",
  1345: 'Subscription activated',
  1346: '{{param1}} Hexatiles',
  1347: 'holding capacity',
  1348: 'Dominion coins',
  1349: '{{param1}} year',
  1350: '{{param1}} years',
  1351: "You can see it on the map in Advisor's domain.",
  1352: "Activate <span style={{color: colors.yellow}}>TerritoryX</span> in Advisor's settings!",
  1353: 'Gaining experience without authorization is not available',
  1354: 'We use cookies to improve your experience on our website.',
  1355: 'By using our site you consent to the use of cookies.',
  1356: 'Date: <span style={{color: colors.orange}}>{{param1}}</span>',
  13561: 'Date',
  1357: 'Price: {{param1}}',
  13571: 'Price:',
  1358: 'Predict: {{param1}}',
  1359: "Owner's new bid:",
  1360: 'Your NEW bid:',
  1361: "You haven't made any bids",
  1362: 'Your offer:',
  1363: 'Your bid in Reex is waiting for an answer',
  1364: 'Advisor not activated.',
  1365: 'Fit to slot {{param1}}',
  1366: 'Will be available for use soon',
  1367: 'Powered by Interaction Alphabet © 2025',
  1368: 'This email is already in use.&nbsp;',
  1369: 'VERIFY YOUR <br /> ACCOUNT',
  1370: 'Hexatile selection',
  1371: 'Choose your hexagon',
  1372: 'ZOOM {{param1}}',
  1373: 'Charge',
  1374: 'Select one at a time',
  1375: 'You selected {{param1}} Hexatiles',
  1376: 'Fill Orb-R map',
  1377: 'Fill R-orb',
  1378: 'Select battery',
  1379: "You don't have battery orbs",
  1380: 'BATTERY',
  1381: 'Referral link',
  1382: 'Market maker',
  1383: 'Purchased hexatiles for all time',
  1384: 'Terra coins received',
  1385: '<Typography variant="body2">Membership in the Federation is granted to every Game Master who has at least one <span style={{color: colors.orange}}>Grand Master Coin</span>. To create it, a candidate coin is required - <span style={{color: colors.orange}}>TERRA Coin</span>.</Typography><Typography variant="body2">Every <span style={{color: colors.orange}}>50</span> hexatiles purchased for HEXA Coin - bring 1 TERRA Coin.</Typography><Typography variant="body2" color={colors.yellow}>More details in the <Link href={\'https://wiki-masters.legendsofinteractions.com/\'} target="_blank" style={{color: colors.yellow, textDecoration: \'underline\'}}>encyclopedia of game masters</Link></Typography>',
  1386: 'Status',
  1387: '<Typography>Your status is a powerful symbol of your achievements in Legends of Interactions. It shows everyone how much you have accomplished and what influence you have in the game world.</Typography><Typography>Your status is what other Game Masters will pay attention to first, including newcomers who have recently arrived in Legends of Interactions.</Typography><Typography>Having a certain status reflects your position on the hierarchical ladder of all Game Masters.</Typography><Typography>This allows you to better understand the current state of your business, assess the capabilities of potential competitors or partners, and determine the paths for further development.</Typography><Typography>This information will be extremely useful when building structures and business alliances in the ecosystem </Typography>',
  1388: '<Typography>Starting with the peasant status, the Game Master will receive an increased amount of OCTA Coin when players interact with the orbs of this Master.</Typography><Typography>This amount increases by 1% with each subsequent status.</Typography><Typography>OCTA Coin is an asset that is of great importance to players, and as the Game develops, the demand for it will only increase.</Typography>',
  1389: 'Withdrawal',
  1390: 'You can have only one external Referral System!',
  1391: 'Root: {{param1}}',
  1392: '(Joined from {{param1}})',
  1393: 'View referral history',
  1394: 'Referrals ({{param1}}):',
  1395: '(Invited {{param1}} more )',
  1396: 'Root Number: {{param1}}',
  1397: '(Created {{param1}})',
  1398: 'If you sell your referral system, you will only be able to create a new one if you buy a root number from another user.',
  1399: 'To join the referral system you need to:',
  1400: 'Buy 14286 hexatiles',
  1401: 'buy a root number from another user',
  1402: 'become someones referral <br />( get a referral link from another user )',
  1403: 'Are you sure you want to join External Referral?',
  1404: 'Back to referral system',
  1405: 'Bonuses from all referrals:',
  1406: 'Nickname',
  1407: 'Structure level',
  1408: 'Amount',
  1409: "You don't have any referral history yet",
  1410: 'VERIFY YOUR TRANSFER',
  1411: 'ENTER BENEFICIARY',
  1412: 'Transaction type',
  1413: 'Currency',
  1414: 'Description',
  1415: "You don't have any transactions yet",
  1416: '{{param1}} Source Orbs',
  1417: 'Loading...',
  1418: 'Notifications',
  1419: 'Mark all as read',
  1420: "You don't have any notifications yet",
  1421: 'You need to top up your balance',
  1422: 'Page not found',
  1423: 'Go to main',
  1424: 'We are updating our service to make it even better and faster.',
  1425: 'Come back to us in',
  1426: 'Hours',
  1427: 'Minutes',
  1428: 'Seconds',
  1429: 'This site is not available on this screen resolution',
  1430: '(Desktop only)',
  1431: 'Click on any advisor (view on map) to transfer hexatiles',
  1432: '{{ param1 }} Hexatiles is your property now',
  1434: 'Click on Hexatiles to select',
  1433: 'Click and drug to select Hexatiles',
  1435: 'You can buy Hexatiles in select mode on ZOOM 18',

  1436: 'MARKETMAKERS',
  1437: 'PERSONAL SHOP',
  1438: 'Only your structure — only your rules!',
  1439: 'Connect a Personal Shop for your Masters of Game structure.',
  1440: 'Flexible settings. Unique offers. Full control over the price.',
  1441: "Hurry up until <span style='color: #FF9326'>December 5, 2025</span>!",
  1442: 'Buy a subscription now and get 2 years of access instead of 1.',
  1443: 'Buy a subscription',
  1444: 'Technologies that understand interaction',
  1445: 'We don’t just create tools — we create a system where everyone can build their own economy.',
  1446: "<span style='color: #FF9326'>Antallagí</span> is a global market. It operates according to universal rules and laws.",
  1447: 'This is exchange, security, scale.',
  1448: 'But precisely because of its universality, it cannot be fine-tuned to a specific project or structure.',
  1449: 'What does the Personal Shop provide?',
  1450: "This is a custom tool created <span style='color: #FF9326'>specifically for you</span> and your Masters of Game structure.",
  1451: 'Easy to use',
  1452: 'No competition',
  1453: 'Only your products',
  1454: 'Only your prices',
  1455: 'Right in the interface of the back office of the Masters of Game of Legends of Interactions',
  1456: "Antallagí and Personal Shop do not compete, but <span style='color: #FF9326'>complement</span> each other.",
  1457: 'Your Shop — your territory',
  1458: 'Separate interface for your Masters of Game structure',
  1459: 'Opportunity to flexibly customize offers',
  1460: 'Conduct of promotions, sales, giveaways',
  1461: 'Usage of in-game currency as discounts',
  1462: 'Simple purchase without creating wallets',
  1463: 'Connection directly to the Master’s back office or to the Game',
  1464: 'Disabling access to Antallagí — optional',
  1465: 'Your structure is your economy',
  1466: 'Each Master of Game registered via your referral link is part of your business network.',
  1467: 'Create your own unique platform for them with offers and your own rules.',
  1468: 'Only you decide what, when and at what price will be available.',
  1469: 'Your rules — your freedom',
  1470: 'Unlike open platforms, there is no race for price.',
  1471: 'You are the only seller.',
  1472: 'You form offers.',
  1473: 'You set the rules.',
  1474: 'Play by your own terms.',
  1475: 'Why Personal Shop, why now?',
  1476: 'Antallagí.io remains a universal tool with the possibility of personalization.',
  1477: 'But the user can see other offers as well.',
  1478: 'The Personal Shop guarantees:',
  1479: 'No competition',
  1480: 'Only your positions',
  1481: "<span style='color: #FF9326'>Use both tools</span>: one — for the market, the other — for working with your Masters of Game structure.",
  1482: 'Subscription price:',
  1483: 'Have you reviewed the offer </br> but haven’t bought a subscription yet?',
  1484: "<span style='color: #FF9326'>Buy a subscription by December 5, 2025</span></br>And get access to the Shop 1 month earlier than others!",
  1485: 'Personal Shop is your private territory.',
  1486: 'While others figure out the settings, you will already start selling.',
  1487: 'Open a Personal Shop for your structure of players',
  1488: 'Trade without competition',
  1489: 'Increase your influence',
  1490: 'Set trends',
  1491: 'Here, only you make the decisions!',
  1492: 'No one knows your players better than you.',
  1493: 'USE THIS!',
  1494: 'Every player in your structure is a consumer.',
  1495: 'The player will look for resources, opportunities and profitable offers.',
  1496: 'Give the player the best choice!',
  1497: 'Make the player come to your Masters of Game Personal Shop!',
  1498: 'Buy a subscription right now and get access to the Shop:',
  1499: '1 month earlier than the rest',
  1500: 'for 2 years instead of one',
  1501: 'What is Personal Shop?',
  1502: 'This is your personal marketplace that will be available </br> to players  in the Legends of Interactions app.',
  1503: 'Here you can sell any goods to players from your structure, provide </br> for their needs and supply resources for a successful gaming process.',
  1504: 'No restrictions',
  1505: 'Only your products, your offers, your prices.',
  1506: 'Support players and benefit from interaction',
  1507: 'Invite members of your structure to the Personal Shop.',
  1508: 'Place unique sales offers for them.',
  1509: 'Set any price you want, regardless of your competitors.',
  1510: 'YOUR STRUCTURE — YOUR BUSINESS.',
  1511: 'HERE YOU DETERMINE THE COURSE OF EVENTS.',
  1512: 'Influence supply and demand',
  1513: 'Sell what is beneficial to you and your players.',
  1514: 'Build sales strategies, strengthening the players’ and your own positions.',
  1515: 'Set trends by increasing or decreasing the popularity of various products.',
  1516: 'Take advantage of the Shop’s wide range of features',
  1517: 'Fine-tune your offers.',
  1518: 'Organize sales, give discounts and gifts.',
  1519: 'Provide players with fast and convenient payment options.',
  1520: 'FREEDOM OF ACTION IS YOUR ADVANTAGE.',
  1521: 'What is the difference between </br> a Personal Shop and Antallagí.io?',
  1522: 'Antallagí.io is a global market driven by competition.',
  1523: 'Personal Shop is your personal trading platform, where everything is subject only to you.',
  1524: 'These are two tools for two different business strategies.',
  1525: "<span style='color: #FF9326;font-size: 40px'>Combine them and get the maximum result</span> </br> from interaction with the inhabitants of the world of Legends of Interactions!",
  1526: 'Your structure should generate income only for you.',
  1527: 'Become an irreplaceable trading partner for it.',
  1528: 'Play by your own rules and shape the market!',
  1529: "<span style='color: Gray'>The offer is available until</span> <span style='color: #FF9326'>05.12.2025</span>",
  1530: 'You already have a subscription',
  1531: 'A you sure you want to buy a subscription?',
  1532: "It will cost <img src='/svgs/dominion.svg' style='margin: 0px 10px -10px 10px'/> {{ param1 }}?",
  1533: "Open a <span style='color: #FF9326;font-size: 28px'>PERSONAL SHOP</span> </br>for your structure of players",
  1534: "Rent for <img src='/svgs/loyaltyIcon.svg' style='margin: 0px 0px -5px 2px; width: 20px'/> {{ param1 }} Loyalty Coin?",
  1535: 'Are you sure you want to rent Hexatile #{{ param1 }}?',
  1536: "It will cost <img src='/svgs/loyaltyIcon.svg' style='margin: 0px 0px -3px 2px'/> {{ param1 }} Loyalty Coin",
  1537: 'Rent will be debited every 30 days',
  1538: 'Are you sure you want to select this Advisor?',
  1539: "The service of <span style='color: #FF9326'>Territory X</span> does <span style='color: #FF9326'>NOT</span> extend to rented areas.",
  1540: 'You have selected to Rent {{ param1 }} Hexatiles',
  1541: 'Required for rent',
  1542: '2 years',
  1543: 'Hexatile #{{ param1 }} is rented',
  1544: 'You can see it on the map in Advisor`s 2 domain',
  1545: 'Are you sure you want to select this Advisor?',
  1546: 'The service of Territory X does NOT extend to rented areas.',
  1547: 'Are you sure you want to place Orb on rented Hexatile?',
  1548: 'if the rent ends, the orb will no longer belongs to you.',
  1549: '({{ param1 }} rented)',
  1550: 'Rented hexatiles',
  1551: 'Are you sure you want to move / sell the last Hexatile?',
  1552: 'If there are no Hexatiles left in this Advisor, it will go into HIBERNATION. It can remain empty for 7 days, after which it will be destroyed.',
  1553: 'There is not a single Hexatile (rented or purchased) in this Advisor.',
  1554: 'It can remain empty in a hibernation state for 7 days, after which it will be destroyed.',
  1555: 'Fill the Advisor with Hexatiles (buy or rent) to bring it out of hibernation.',
  1556: 'You can get Loyalty Coin by logging in to Master of Game every day and completing quests (coming soon)',
  1557: 'Loyalty Coin is a special coin designed for renting land plots in Legends Of Interaction. The coin can only be used by Master of Game. You can get Loyalty Coin by logging in to Master of Game every day and completing quests (coming soon)',
  1558: '{{ param1 }} become empty and has gone into HIBERNATION for 7 days.',
  1559: ' Fill it with Hexatiles (buy or rent), or it will be destroyed.',
  1560: 'There is not a single Hexatile (rented or purchased) in this Advisor.',
  1561: 'It can remain empty in a hibernation state for 7 days, after which it will be destroyed.',
  1562: 'Fill the Advisor with Hexatiles (buy or rent) to bring it out of hibernation.',
  1563: 'Wellcome to <br/> MASTERS OF GAME',
  1564: "Rewards for <span style='color: #FF9326'>DAY {{ param1 }}</span> :",
  1565: "Rewards for the <span style='color: #FF9326'>WEEK</span> :",
  1566: "Rewards for the <span style='color: #FF9326'>MOUNTH</span> :",
  1567: "<span style='color: #FF9326'>{{ param1 }}</span> Hexatiles <br/> successfully moved.",
  1568: "You can see it on the map in <span style='color: #FF9326'>{{ param2 }}</span> domain.",
  1569: 'Not activated',
  1570: 'Are you sure you want to activate / update Territory X?',
  1571: 'Are you sure you want to cancel this purchase?',
  1572: "This action will end bidding and the hexatile information will return to the tab «<span style='color: #FF9326'>World</span>»",
  1573: 'Yes, I want to cancel purchase',
  1574: 'No, return to bids',
  1575: 'You can view and place Orbs only on ZOOM 19 and more.',
  1576: "Please <span style='color: #FF9326'>enlarge</span> the map.",
  1577: 'Orbs can only be placed on purchased Hexatiles.',
  1578: 'Select Hexatile that belongs to you.',
  1579: 'Your SALE orders will be automatically removed after 10 days if there will be no purchase offers.',
  1580: 'View on map to see the details.',
  1581: '{{ param1 }} days left',
  1582: 'Your SALE order will be automatically removed after 10 days if there will be no purchase offers',
  1583: "Hexatile #{{ param1 }} was sold for <img src='/svgs/reex.svg' style='margin: 0px 5px -10px 3px'/> {{ param2 }}",
  1584: 'This opportunity is only available to focus group participants. <br/> If you are interested, please contact the person who invited you here.',
  1585: 'Referral codes:',
  1586: 'Сodes are updated automatically after activation.',
  1587: 'Unavailable',

  1600: 'Available: {{param1}}',
  1601: 'Click to place',
  1602: 'Zoom in to level {{param1}} to place a miner',
  1603: 'No miners yet',

  1604: 'Miner',
  1605: 'Available to collect',
  1606: 'Total collected',
  1607: 'Last collect',
  1608: 'The miner is full and has stopped. Collect the REEX to continue mining',
  1609: 'Click to collect',
  1610: 'Nothing to collect yet',

  1611: 'My masters',
  1612: 'My shop',
  1613: 'LOI Referral',
  1614: 'Templates',
  1615: 'Create',
  1616: 'Preview',
  1617: 'Subscription',
  1618: 'Shop subscription required',
  1619: 'An active market maker subscription is required to own a shop.',
  1620: 'Go to subscription',
  1621: 'No templates yet',
  1622: 'Create the first one',
  1623: 'This is how buyers see your shop',
  1624: 'No template is on sale — buyers see an empty shop',
  1625: 'Shop subscription',
  1626: 'Subscription is active',
  1627: 'No subscription',
  1628: 'Valid until {{param1}}',
  1629: 'Renew or buy',
  1630: 'Buy',
  1631: '1 year',
  1632: '2 years',
  1633: '3 years',
  1634: '99 years',
  1635: 'Buy the "{{param1}}" subscription for {{param2}} {{param3}}?',
  1636: 'Subscription payment will be available soon',

  1637: 'On sale: {{param1}}',
  1638: 'Not on sale',
  1639: '{{param1}} items',
  1640: 'Description',
  1641: 'Price',
  1642: 'On sale: {{param1}}',
  1643: 'Not on sale',
  1644: 'Template contents ({{param1}})',
  1645: 'The pack is empty.',
  1646: 'Delete',
  1647: 'Price (Reex)',
  1648: 'On sale',
  1649: 'Save',
  1650: 'Remove from sale',
  1651: 'Create a template',
  1652: 'Orbs',
  1653: 'Coins',
  1654: 'Empty here',
  1655: 'Template image',
  1656: 'Upload image',
  1657: 'Change image',
  1658: 'Template name',
  1659: 'In the template ({{param1}})',
  1660: 'Cancel',
  1661: 'Creating...',
  1662: 'Too many',

  1663: 'No offers yet',
  1664: 'Purchase unavailable',
  1665: 'You are a market maker.',
  1666: 'Left: {{param1}}',
  1667: 'Seller',
  1668: 'Price per pack',
  1669: 'Pack contents ({{param1}})',
  1670: 'No data about the contents.',
  1671: 'Quantity',
  1672: 'Total',
  1673: 'Preview — purchase unavailable',
  1674: 'Purchased: {{param1}} ×{{param2}}',
  1675: 'Buy «{{param1}}» ×{{param2}} for {{param3}} Reex?',
  1676: 'Joins:',
  1677: 'Quantity (± on sale)',
  1678: 'Add to sale',
  1679: 'Put on sale',
  1680: 'Reward collected',
  1681: 'Collected: {{param1}} REEX',

  1682: 'From',
  1683: 'To',
  1684: 'Show',
  1685: 'Export CSV',
  1686: 'Resource',
  1687: 'Transactions',
  1688: 'Report',

  1689: '{{param1}} year',
  1690: '{{param1}} years',
  1691: 'The term will be added to your current expiry date.',
  1692: 'After this purchase you become a market maker and will be moved out of your current structure.',

  1693: 'Buy Dominion',
  1694: 'AMOUNT',
  1695: 'PAYMENT CURRENCY',
  1696: 'Soon',
  1697: 'Balance: {{param1}}',
  1698: 'Cryptocurrency',
  1699: '{{param1}} network',
  1700: 'Total:',
  1701: 'NOT ENOUGH {{param1}}',
  1702: 'BUY {{param1}} {{param2}}',
  1703: 'Rate: {{param1}} REEX for 1 {{param2}}. Other payment methods will be added later.',
  1704: 'Purchased {{param1}} {{param2}}',
  1705: 'Buy {{param1}} {{param2}} for {{param3}}?',

  1706: 'Personal offers',
  1707: 'A special price on a number of packs for a specific player from your structure. Personal offers are used before the regular price and disappear once used up.',
  1708: 'Player',
  1709: 'No personal offers for this template',
  1710: 'Add',
  1711: 'Remove the personal offer for {{param1}}?',
  1712: 'Personal price',
  1713: 'Personal price for the first {{param1}} packs',
  1714: '{{param1}} at personal price, {{param2}} at regular price',
  1715: 'Sale',
  1716: 'Player #{{param1}}',
  1717: 'Personal: {{param1}}',
  1718: 'Loading rate…',
  1719: 'Failed to load the exchange rate. Purchase is temporarily unavailable.',
  1720: 'Retry',
  1721: 'RATE UNAVAILABLE',
  1722: 'Referral link',
  1723: 'Get masters',
  1724: 'Masters of Game',
  1725: 'In this section, you will be able to place an order to receive Masters of Game through global advertising campaigns. To place an order, you must send a special 1GM token to your internal address for receiving resources. If you would like to learn more about 1GM, please contact your upline Market makers.',
  1726: 'Unlimited',
  1727: 'Valid forever',
  1728: 'You have an unlimited subscription - nothing else to buy.',
  1729: 'Get your own Masters of Game through a global advertising campaign',
  1730: 'You can order registration for yourself',
  1731: 'Order',
  1732: 'The option to order registration of the Master of Game will be enabled later.',
  1733: 'Zoom in to level {{param1}} to move orbs',
  1734: '1GM is a special token used to order the registration of Masters of Game through global advertising campaigns. To learn more about 1GM, please contact your upline Market makers.',
  1735: 'SUPPORT',
  1736: 'New ticket',
  1737: 'Subject',
  1738: 'Message',
  1739: 'Create ticket',
  1740: 'You have no tickets yet',
  1741: 'Back to tickets',
  1742: 'Write a reply',
  1743: 'Reply',
  1744: 'Open',
  1745: 'Closed',
  1746: 'Support',
  1747: 'You',
  1748: 'This ticket is closed, you can no longer reply.',
  1749: 'Cancel',
  1750: 'No messages in this ticket yet',
  1751: 'Answered',
  1752: 'ORB',
  1753: 'R-ORB',
  1754: 'R-ORB MAP',
  1755: 'REEX MINER',
  1756: 'Item',
  1757: 'This section is available to market makers only',
  1758: 'Hit a drone and get {{param1}} Loyalty coins. Each shot costs {{param2}} Loyalty coin.',
  1759: 'Sign up to take part',
  1760: 'Top up your balance to continue',
  1761: 'Top up',
  1762: 'Price in other currencies',
  1763: 'At least {{param1}} REEX must accumulate before you can collect',
  1764: 'Pulse',
  1765: 'Shop pulse',
  1766: 'Turnover and everything that explains it. This screen answers the question "why am I paying for the subscription".',
  1767: 'REVENUE, LAST MONTH',
  1768: '{{param1}} sales',
  1769: 'YOUR RANK',
  1770: 'out of {{param1}} shops in the last month',
  1771: 'no sales in the last month',
  1772: 'EMPTY LANDS',
  1773: 'lands of your masters without a single object',
  1776: 'CAPACITY',
  1777: 'this many packs are on sale right now',
  1785: 'Masters with empty lands',
  1787: 'Analytics will appear once the server starts providing it',
  1790: 'No data yet',
  1793: '{{param1}} of {{param2}} lands empty',
  1794: 'All lands of your masters are built up',
  1795: 'Sales leaderboard, last month',
  1796: 'anonymous ranking of all shops by sales in the period',
  1797: 'Your shop',
  1798: 'My data',
  1799: 'Leaderboard',
  1800: 'Can put on sale: {{param1}}',
  1801: 'Up to {{param1}} with current assets',
  1802: 'Not enough assets to put more on sale',
  1803: 'Shop',
  1804: 'My requests',
  1805: 'Requests',
  1806: 'Tell your market maker what you need',
  1807: 'New request',
  1808: '{{param1}} of {{param2}} requests',
  1809: 'No requests yet',
  1810: 'Packs: {{param1}}',
  1811: '{{param1}} Reex per pack',
  1812: 'Total: {{param1}} Reex',
  1813: 'Choose what you want to buy',
  1814: 'In the request ({{param1}})',
  1815: 'Nothing selected yet',
  1816: 'Number of packs',
  1817: 'Price per pack (Reex)',
  1818: 'Create request',
  1819: 'Requests from your masters',
  1820: 'Your masters have not requested anything yet',
  1821: 'Close request',
  1822: 'Limit reached: delete a request to create a new one',
  1823: 'No resources are available for requests',
  1824: 'What your masters want to buy. Close a request once it is fulfilled.',
  1825: 'The game is in early beta',
  1826: 'Legends of Interactions is at an early stage of development. Features and content are still being added and may change from version to version.',
  1827: 'The latest version of the game is available on the official website',
  1828: 'Download the game',
  1829: 'Invite codes for LOI',
  1830: 'ACCUMULATED',
  1831: 'Click the orb to collect',
  1832: 'Nothing has accumulated yet',
  1833: 'Extras',
  1834: 'Special game features',
  1835: 'Player emulators',
  1836: 'Attach an emulator to an advisor, and it will collect resources for you.',
  1837: 'FREE EMULATORS',
  1838: 'Attach emulator',
  1839: 'Active',
  1842: 'No free emulators',
  1843: 'Attach an emulator to the advisor «{{param1}}»?',
  1844: 'The emulator will start collecting resources for this advisor.',
  1847: 'You have no advisors yet',
  1848: 'Hexes: {{param1}} / {{param2}}',
  1851: 'Chief',
  1852: 'Active since {{param1}}',
  1853: 'BATTERY',
  1854: 'Return to inventory',
  1855: 'Return the emulator of the advisor «{{param1}}» to the inventory?',
  1856: 'The emulator will stop collecting resources and become free again.',
}

export default translation
